import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { TermsAndConditions } from './TermsAndConditions';
export function Footer() {
  const {
    language
  } = useLanguage();
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-gray-900 text-gray-400 py-10 border-t border-gray-800" data-id="element-34">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-3" data-id="element-35">
          <button onClick={() => setShowTerms(true)} className="text-sm text-gray-500 hover:text-white underline underline-offset-2 transition-colors" data-id="element-36">
            {language === 'en' ? 'Terms and Conditions' : 'Términos y Condiciones'}
          </button>
          <p className="text-sm text-gray-600" data-id="element-37">
            © {new Date().getFullYear()} CV Go App.{' '}
            {language === 'en' ? 'All rights reserved.' : 'Todos los derechos reservados.'}
          </p>
        </div>
      </footer>

      <TermsAndConditions isOpen={showTerms} onClose={() => setShowTerms(false)} data-id="element-38" />
    </>;
}